import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import type { AppStatusConfig } from '~/core/components/incident-communication/models/AppStatusConfig';
import { StatusMode } from '~/core/components/incident-communication/models/AppStatusConfig';
import {
  getIncidentBannerDismissed,
  setIncidentBannerDismissed,
  clearIncidentBannerDismissed,
} from '~/utils/local-storage-utils/local-storage-utils';
import { useAppStatusConfig } from './use-app-status-config';

type TargetMode = StatusMode.GlobalMaintenanceBanner | StatusMode.SecuredMaintenanceBanner;

export interface UseIncidentBannerResult {
  showBanner: boolean;
  config: AppStatusConfig;
  dismiss: () => void;
}

export const useIncidentBanner = (target: TargetMode): UseIncidentBannerResult => {
  const config = useAppStatusConfig();
  const onWebView = useSelector((s: AppState) => s.native.onWebView);
  const [dismissed, setDismissed] = useState(() => getIncidentBannerDismissed());

  useEffect(() => {
    if (config.statusMode === StatusMode.Operational) {
      clearIncidentBannerDismissed();
      setDismissed(false);
    }
  }, [config.statusMode]);

  const showBanner = config.statusMode === target && onWebView === false && !dismissed;

  const dismiss = useCallback(() => {
    setIncidentBannerDismissed();
    setDismissed(true);
  }, []);

  return { showBanner, config, dismiss };
};
